import {useRef} from 'react';
import {contextMenu} from 'react-contexify';

import {observer} from 'mobx-react-lite';

import type {Clickable} from '@yourcoach/shared/uikit/Clickable';
import type {GetComponentProps} from '@yourcoach/shared/utils/utility-types';

import {currentUserStore} from '@yourcoach/shared/api/user';
import {AvatarPlaceholder} from '@yourcoach/shared/uikit/AvatarPlaceholder';
import {getFileSrc} from '@yourcoach/shared/utils/entity/file';

import {ProfileContextMenu} from './ProfileContextMenu';
import * as S from './styles';

const CONTEXT_MENU_ID = 'profile_context_menu';

export const HeaderRightSide = observer(() => {
  const ref = useRef<HTMLDivElement>(null);

  const handleShowMenu: GetComponentProps<typeof Clickable>['onClick'] = e => {
    const event = e.event.DOMEvent;

    if (!ref.current || !event) {
      return;
    }

    const rect = ref.current.getBoundingClientRect();

    contextMenu.show({
      event,
      id: CONTEXT_MENU_ID,
      position: {
        /**
         * TODO: Figure out how to get right position depends on context menu width
         * 200 is the context menu width
         */
        x: rect.x + rect.width - 200,
        y: rect.y + rect.height + 8,
      },
    });
  };

  return (
    <div ref={ref}>
      <S.Container onClick={handleShowMenu}>
        <S.AvatarContainer>
          <S.Avatar
            placeholder={
              <AvatarPlaceholder text={currentUserStore.user?.name} />
            }
            src={getFileSrc(currentUserStore.user?.avatar).url}
          />
        </S.AvatarContainer>
        <S.UseNameContainer>{currentUserStore.user?.name}</S.UseNameContainer>
        <S.Icon />
      </S.Container>
      <ProfileContextMenu menuId={CONTEXT_MENU_ID} />
    </div>
  );
});
